'use strict';

angular.module('far.discipline')
    .controller('DisciplineRankEditController', function ($rootScope, $scope, $log, $http, $window, $location, Rank, RankSeason) {
        var vm = {
            progress: true,
            submitted: false,
            model: {
                values: []
            },
            title: [],
            seasonList: [],
            seasonModel: {},
            seasonModal: false,
            disciplineUrl: '',
            getRank: function () {
                vm.progress = true;

                vm.model.title = [];
                vm.title = [];

                vm.seasonList.map(function (season) {
                    if (season.id == vm.model.season) {
                        vm.title.push(season.name + ' год')
                    }
                });

                vm.model.values = [];

                vm.model = Rank.get(vm.model, function () {
                    if (vm.model.values.length) {
                        vm.model.values = vm.model.values.map(function (value) {
                            value.qualification = value.qualification.id.toString();

                            return value;
                        });
                    }

                    if (vm.model.values.length < 10) {
                        vm.addRankEmpty(10-vm.model.values.length)
                    }

                    vm.progress = false;
                });
            },
            getRankSeason: function () {
                vm.seasonList = [];

                $http.get(Routing.generate('api_discipline_get_discipline_rank_seasons'))
                    .then(function (response) {
                        response.data.forEach(function (item, index) {
                            if (index == 0 && vm.model.season == undefined) {
                                vm.model.season = item.id.toString();
                            }

                            vm.seasonList.push(item);
                        });

                        vm.getRank();
                    }, function (response) {
                        $log.error(response);

                        vm.progress = false;
                    });
            },
            addRankEmpty: function (max) {
                for (var i = 0; i < max; i++) {
                    vm.model.values.push({
                        points: '',
                        name: '',
                        city: '',
                        age: '',
                        qualification: vm.rankValueQualification
                    });
                }
            },
            init: function () {
                vm.seasonModel = RankSeason.new();

                vm.getRankSeason();
            },
            seasonSubmit: function () {
                if (vm.submitted || $scope.rankSeasonForm.$invalid) {
                    return;
                }

                vm.submitted = true;

                vm.seasonModel.save()
                    .then(function (response) {
                        vm.seasonModel.name = '';

                        vm.model.season = response.data.id.toString();

                        vm.getRankSeason();

                        vm.seasonModal = false;
                        vm.submitted = false;
                    }, function () {
                        vm.seasonModel.name = '';

                        vm.seasonModal = false;
                        vm.submitted = false;
                    });
            },
            submit: function () {
                if (vm.submitted) {
                    return false;
                }

                vm.submitted = true;

                vm.model
                    .save()
                    .then(function () {
                        $window.location.href = Routing.generate('discipline_rank', {url: vm.disciplineUrl});
                    }, function (response) {
                        $log.error(response);

                        vm.submitted = true;
                    });
            }
        };

        return vm;
    });
